const prod_host = "https://server.mapit.cc";

const refreshAccess = (refreshToken, callback) => {
    console.log(`Debug Log: Sending server request to refresh access token.`);
    fetch(`${prod_host}/token`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            token : refreshToken
        })
    })
    .then(response => response.json())
    .then(serverResponse => {
        console.log(`Debug Log: Retrieved new access token from sever.`);
        callback("", serverResponse.accessToken);
    })
    .catch((error) => {
        console.log(`Debug Log: In Function refreshAccess with error: ${error}`);
        callback(error, "");
    });
}

export const getTrxAndEditIds = (projId, callback) => {
    console.log(`Debug Log: Sending request to get trx and edit ids`);
    const accessToken = localStorage.getItem("aToken");
    const refreshToken = localStorage.getItem("rToken");

    fetch(`${prod_host}/getTrxAndEditIds`, {
        method: 'post',
        headers: {'Content-Type': 'application/json', 
        'authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
          projId: projId
        })
      })
      .then(response => response.json())
      .then(trxIds => {
        if (trxIds.message === 'jwt expired') {
            refreshAccess(refreshToken, function (error, accessToken) {
                if (error) {
                    callback(error, []);
                } else {
                    console.log(`Debug Log: JWT expired. New access token received.`);
                    localStorage.setItem("aToken", accessToken);
                    getTrxAndEditIds(projId, callback);
                }
            });
        } else {
            console.log(trxIds);
            callback("", trxIds);
        }
      })
      .catch ((error) => {
        console.log(`exception occurred during getTrxAndEditIds fetch request`);
        console.log(error, "");
        callback(error, "");
      });
}

export const stripeCheckoutSession = (email, sub_plan, fpObj, address, callback) => {
    console.log(`Debug Log: Sending request to create stripe checkout session`);
    const accessToken = localStorage.getItem("aToken");
    const refreshToken = localStorage.getItem("rToken");

    fetch(`${prod_host}/create-checkout-session`, {
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          email: email,
          subPlan: sub_plan,
          fpObj: fpObj,
          propAddress: address
        })
      })
      .then(response => response.json())
      .then(session => {
        if (session.message === 'jwt expired') {
            refreshAccess(refreshToken, function (error, accessToken) {
                if (error) {
                    callback(error, []);
                } else {
                    console.log(`Debug Log: JWT expired. New access token received.`);
                    localStorage.setItem("aToken", accessToken);
                    stripeCheckoutSession(email, sub_plan, fpObj, address, callback);
                }
            });
        } else {
            console.log(session);
            callback("", session);
        }
    })
    .catch((err) => {
        console.log("exception occurredduring checkout session");
        console.log(err);
        callback(err, []);
    });
}

export const addProjectTier1 = (email, product_type, fpObj, address, callback) => {
    console.log(`Debug Log: Sending request to get trx and edit ids`);
    const accessToken = localStorage.getItem("aToken");
    const refreshToken = localStorage.getItem("rToken");

    fetch(`${prod_host}/addProjectTier1`, {
        method: 'post',
        headers: {'Content-Type': 'application/json', 
        'authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
            email: email,
            product_type: product_type,
            fpObj: fpObj,
            propAddress: address,
        })
      })
      .then(response => response.json())
      .then(trxObj => {
        if (trxObj.message === 'jwt expired') {
            refreshAccess(refreshToken, function (error, accessToken) {
                if (error) {
                    callback(error, []);
                } else {
                    console.log(`Debug Log: JWT expired. New access token received.`);
                    localStorage.setItem("aToken", accessToken);
                    addProjectTier1(email, product_type, fpObj, address, callback);
                }
            });
        } else {
            console.log(trxObj);
            callback("", trxObj);
        }
      })
      .catch ((error) => {
        console.log(`exception occurred during addProjectTier1 fetch request`);
        console.log(error, "");
        callback(error, "");
      });
}

export const getSubAndProjects = (email, callback) => {
    console.log(`Debug Log: sending request to getSubAndProjects`);
    const accessToken = localStorage.getItem("aToken");
    const refreshToken = localStorage.getItem("rToken");

    fetch(`${prod_host}/getSubAndProjects`, {
        method: 'post',
        headers: {'Content-Type': 'application/json', 
        'authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
            email: email
        })
      })
      .then(response => response.json())
      .then(trxObj => {
        if (trxObj.message === 'jwt expired') {
            refreshAccess(refreshToken, function (error, accessToken) {
                if (error) {
                    callback(error, []);
                } else {
                    console.log(`Debug Log: JWT expired. New access token received.`);
                    localStorage.setItem("aToken", accessToken);
                    getSubAndProjects(email, callback);
                }
            });
        } else {
            console.log(trxObj);
            callback("", trxObj);
        }
      })
      .catch ((error) => {
        console.log(`exception occurred during getSubAndProjects fetch request`);
        console.log(error, "");
        callback(error, "");
      });
}

export const getUserSub = (email, callback) => {
    console.log(`Debug Log: sending request to getSubAndProjects`);
    const accessToken = localStorage.getItem("aToken");
    const refreshToken = localStorage.getItem("rToken");

    fetch(`${prod_host}/getUserSub`, {
        method: 'post',
        headers: {'Content-Type': 'application/json', 
        'authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
            email: email
        })
      })
      .then(response => response.json())
      .then(trxObj => {
        if (trxObj.message === 'jwt expired') {
            refreshAccess(refreshToken, function (error, accessToken) {
                if (error) {
                    callback(error, []);
                } else {
                    console.log(`Debug Log: JWT expired. New access token received.`);
                    localStorage.setItem("aToken", accessToken);
                    getSubAndProjects(email, callback);
                }
            });
        } else {
            console.log(trxObj);
            callback("", trxObj);
        }
      })
      .catch ((error) => {
        console.log(`exception occurred during getSubAndProjects fetch request`);
        console.log(error, "");
        callback(error, "");
      });
}

export const cancelSub = (email, callback) => {
    console.log(`Debug Log: sending request to cancelSub`);
    const accessToken = localStorage.getItem("aToken");
    const refreshToken = localStorage.getItem("rToken");

    fetch(`${prod_host}/cancelSub`, {
        method: 'post',
        headers: {'Content-Type': 'application/json', 
        'authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
            email: email
        })
      })
      .then(response => response.json())
      .then(trxObj => {
        if (trxObj.message === 'jwt expired') {
            refreshAccess(refreshToken, function (error, accessToken) {
                if (error) {
                    callback(error, []);
                } else {
                    console.log(`Debug Log: JWT expired. New access token received.`);
                    localStorage.setItem("aToken", accessToken);
                    cancelSub(email, callback);
                }
            });
        } else {
            console.log(trxObj);
            callback("", trxObj);
        }
      })
      .catch ((error) => {
        console.log(`exception occurred during cancelSub fetch request`);
        console.log(error, "");
        callback(error, "");
      });
}

export const resubscribe = (email, callback) => {
    console.log(`Debug Log: sending request to resubscribe`);
    const accessToken = localStorage.getItem("aToken");
    const refreshToken = localStorage.getItem("rToken");

    fetch(`${prod_host}/resubscribe`, {
        method: 'post',
        headers: {'Content-Type': 'application/json', 
        'authorization': `Bearer ${accessToken}`
        },
        body: JSON.stringify({
            email: email
        })
      })
      .then(response => response.json())
      .then(trxObj => {
        if (trxObj.message === 'jwt expired') {
            refreshAccess(refreshToken, function (error, accessToken) {
                if (error) {
                    callback(error, []);
                } else {
                    console.log(`Debug Log: JWT expired. New access token received.`);
                    localStorage.setItem("aToken", accessToken);
                    resubscribe(email, callback);
                }
            });
        } else {
            console.log(trxObj);
            callback("", trxObj);
        }
      })
      .catch ((error) => {
        console.log(`exception occurred during resubscribe fetch request`);
        console.log(error, "");
        callback(error, "");
      });
}
